module.exports = __webpack_public_path__ + "img/DTYLX_fr.452beab9.png";